import gButton from "@/components/g-button/g-button";
import gForm from "@/components/g-form/g-form";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, requiredIf } from "@vuelidate/validators";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import OrcamentoSequenciaController from "@/shared/controllers/orcamentoSequencia/orcamentoSequenciaController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import { defineComponent } from "vue";



const name = 'CaracProdutoRA'
export default defineComponent({
  name,

  components: {
    'g-form': gForm,
    'g-button': gButton
   },

  props: {

  },

  setup(){
    return {
      v$: useVuelidate()
    }
  },

  mounted () {
    OrcamentoController.VerificaSeOrcamentoTemQuantidade(this.$route.params.id).requisicao
    .then((response) => {
      if(response.data.data == false){
        this.$toast.add({severity:'error', detail:'Erro ao Salvar Quantidade. Por favor tente novamente.', life: 5000})
        this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/info-basicas-ra`)
      }
    })
    this.ImagemEmpresa();
    this.getLoteSequencia();
    this.getComponentesByProdutoIdSelecionado();
    this.getReorcamento();
    this.getCaracteristicasProduto();

    this.getOrcamentoSequencia();

    this.TiposOrcamentoArray = OrcamentoSequenciaController.GetTiposOrcamento().TiposOrcamentoArray;
    this.ProdutoArray = ProdutoController.GetProdutoByOrcamentoClienteEmpresa(this.$route.params.id).ProdutoArray

  },

  updated () { },

  data () {
    return {
      status: 0,
      popupCancelaOrc: false,
      AbrirPopupPadrao: false,
        Colunas: [
          {field: 'tipo', header: 'Tipo'},
          {field: 'produto', header: 'Produto'},
        ],
        InformacaoProdutosSequencia: [],
        produtoId: null,
        ProdutoArray: [],
        TipoOrcamentoEnum: null,
        TiposOrcamentoArray: [],
        imagemEmpresa: '',
        temLote: '',
        comprimentoPalete: '',
        larguraPalete: '',
        alturaPalete: '',
        melhorAproveitamento: false,
        observacaoPalete: '',
        copiaOrcamentoQuantidade:false,
        reorcamento: false,
        optionsgerais: [],
        optionscriticas: [],
        optionsespecifica: [],
        popup: false,

        tipoSelecionado: 0,
        loteSelecionado: '',
        sequenciaSelecionado: false,

        OrcamentoCaracteristicasArray: [],
        legislacao: false,
        fsc: false,
        solvente: false,
        embalagemEspecificaFilmeEncolhivel: false,
        embalagemEspecificaCaixaColetiva: false,
        embalagemEspecificaPalete: false,
        critica1: false,
        critica2: false,
        critica3: false,
        critica4: null,
        critica5: false,
        DescricaoOutrasEmbalagens: '',
        DescricaoOutrasEmbalagensEspecificas:'',
        embalagemOutros: false,
        loteInfoText: '',
        sequenciaValue: false,
        observacao: '',
        descricao: '',
        descricaoespec: '',
        sequenciaDescricao: '',
        sugestaoSequencia: [ {
            texto: 'Padrão',
            valor: 0
          },
          {
            texto: 'Especifico',
            valor: 1
          }
        ],

        sugestaoLotes: [
          {
            nome: 'Lote 1',
            valor: 0
          },
          {
            nome: 'Lote 2',
            valor: 1
          },
          {
            nome: 'Lote 3',
            valor: 2
          },
        ],

        opcoesTipo: [
          {
            texto: 'Padrão',
            valor: 0
          },
          {
            texto: 'Especifico',
            valor: 1
          }
        ],
        informacao: [],
        checkAmostra: null,
        amostraTecnica: null,
        papelSeda: false,
        medidaPapelSeda: '',
        medidaPapelSeda2: '',
        CodigoOrcamento: null
     }
  },

  validations() {
    let sequenciaDescricaoValidation;
    let loteDescricaoValidation;
    let outrosDescricaoValidation;
    let temSequencia = this.sequenciaValue;
    let temOutrosDescricao = this.embalagemOutros;



    if (temOutrosDescricao) {
      outrosDescricaoValidation = {
        required: helpers.withMessage(
          "O campo Descrição Outros é obrigatório",
          required
        ),
      };
    } else {
      outrosDescricaoValidation = {};
    }

    if (this.temLote) {
      loteDescricaoValidation = {
        required: helpers.withMessage(
          "O campo Descrição Lote é obrigatório",
          required
        ),
      };
    } else {
      loteDescricaoValidation = {};
    }
    if (temSequencia) {
      sequenciaDescricaoValidation = {
        required: helpers.withMessage(
          "O campo Descrição de Sequência é obrigatório",
          required
        ),
      };
    } else {
      sequenciaDescricaoValidation = {};
    }


    if (!this.temLote && !temSequencia) {
      loteDescricaoValidation = {};
      sequenciaDescricaoValidation = {};
    }

    let validaCamposPalete = this.embalagemEspecificaPalete && !this.melhorAproveitamento
    let alturaPaleteValidation = {require: helpers.withMessage('o campo altura para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};
    let larguraPaleteValidation = {require: helpers.withMessage('o campo largura para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};
    let comprimentoPaleteValidation = {require: helpers.withMessage('o campo comprimento para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};

    return {
      critica3: {require: helpers.withMessage("O campo de Fechamento por Máquina precisa ser preenchido", required)},
      sequenciaDescricao: sequenciaDescricaoValidation,
      loteSelecionado: loteDescricaoValidation,
      descricao: outrosDescricaoValidation,
      alturaPalete: alturaPaleteValidation,
      larguraPalete: larguraPaleteValidation,
      comprimentoPalete: comprimentoPaleteValidation,

    }
  },

  methods: {
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-repeticao-alteracao-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `//${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    getOrcamentoSequencia(){
      OrcamentoSequenciaController.GetOrcamentoSequenciaByOrcamentoId(this.$route.params.id).requisicao
      .then(res => {
        this.InformacaoProdutosSequencia = res.data.data.informacaoProdutosSequencia
      });
    },
    LimparProduto(){
      if(this.TipoOrcamentoEnum == 0)
      {
        this.produtoId = null
      }
    },
    excluir(data) {
      let dataEmString = JSON.stringify(data)
      this.InformacaoProdutosSequencia = this.InformacaoProdutosSequencia.filter(e => JSON.stringify(e) != dataEmString)
    },

    adicionarProdutoAoGrid(){
      if(this.TipoOrcamentoEnum == null && this.produtoId == null)
      {
        this.$toast.add({ severity: 'error', summary: 'Selecione um Tipo e um Produto', detail: 'Tipo e Produto Obrigatórios', life: 4000 });
        return
      }
      if(this.TipoOrcamentoEnum == null && this.produtoId != null)
      {
        this.$toast.add({ severity: 'error', summary: 'Selecione um Tipo e um Produto Também', detail: 'Tipo e Produto Obrigatórios', life: 4000 });
        return
      }
      if((this.TipoOrcamentoEnum == 1 && this.produtoId == null) || (this.TipoOrcamentoEnum == 2 && this.produtoId == null) )
      {
        this.$toast.add({ severity: 'error', summary: 'Produto Obrigatório', detail: 'Selecione um produto', life: 4000 });
        return
      }

      if(this.TipoOrcamentoEnum != 0)
      {
        let Produto = this.ProdutoArray.find((Element) => Element.produtoId == this.produtoId)
        let TipoText = this.TiposOrcamentoArray.find((Element) => Element.enum == this.TipoOrcamentoEnum)

        let variavel =
          {"produtoId": this.produtoId, "tipoEnum": this.TipoOrcamentoEnum, "tipo":TipoText.text, "produto": Produto.nomeProduto }
          this.InformacaoProdutosSequencia.push(variavel)

        return
      }

      if(this.TipoOrcamentoEnum == 0)
      {
        let TipoText = this.TiposOrcamentoArray.find((Element) => Element.enum == this.TipoOrcamentoEnum)
        let variavel =
          {"produtoId":null, "tipoEnum": this.TipoOrcamentoEnum, "tipo": TipoText.text, "produto": null }


          this.InformacaoProdutosSequencia.push(variavel)

        return
      }


    },






    insertOrcamentoVariacao() {
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Orcamento/InsertOrReplaceOrcaProdRepet/${this.$route.params.id}`,
        data:{
       }
     })
        .then((response) => {
         this.OrcamentoId = response.data.data
         if (!response.data) {
           this.$toast.add({severity:'error', summary: 'Erro', detail: 'Nao foi possivel criar a copia do orcamento', life: 5000})
           return
         }
         if (!this.OrcamentoId) {
           this.$toast.add({severity:'error', summary: 'Erro', detail: 'Nao foi possivel criar a copia do orcamento', life: 5000})
           return
         }
         this.$router.push(`/produto-repeticao-alteracao/${this.OrcamentoId}/info-cliente-ra`)
        })
        .catch(() => { });
    },

    getLoteSequencia ()
    {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetLoteSequenciaByOrcamentoId/${this.$route.params.id}`,
      })
        .then((response) => {
            this.loteInfoText = response.data.data. informacaoLoteText
            this.sequenciaValue = response.data.data.sequencia
           if (this.loteInfoText === "Não") {
            this.temLote = false
           } else {
            this.temLote = true
           }

        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },

    validateCriticas () {

      if(this.v$.$invalid === true){
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
          return
        })

      }else{
        this.salvarOrcamentoCaracteristicas()
        }
    },

    removerNaoDigitos(textoOriginal){
      if(!textoOriginal) return null;
      return textoOriginal.replaceAll(/\D/gm, '');
    },

    camponumero ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },

    aplicarCentimetro(valor){
      if(!this[valor]) return;
      this[valor] += ' cm'
    },

    salvarOrcamentoCaracteristicas ()
    {
      this.$isLoading(true)
      let OrcamentoCaracteristicasArray = {
        FSC : this.fsc,
        Tipo: this.tipoSelecionado,
        Legislacao: this.legislacao,
        Critica1: this.critica1,
        Critica2: this.critica2,
        Critica3: this.critica3,
        Critica4: this.critica4,
        Critica5: this.critica5,
        EmbalagemOutros: this.embalagemOutros,
        DescricaoOutrasEmbalagens: this.embalagemOutros ? this.descricao : '',
        DescricaoOutrasEmbalagensEspecificas: this.descricaoespec,
        Observacao: this.observacao,
        EmbalagemEspecificaFilmeEncolhivel: this.embalagemEspecificaFilmeEncolhivel,
        EmbalagemEspecificaCaixaColetiva: this.embalagemEspecificaCaixaColetiva,
        EmbalagemEspecificaPalete: this.embalagemEspecificaPalete,
        Lote: this.loteSelecionado,
        DescricaoSequencia: this.sequenciaDescricao!= '' ? this.sequenciaDescricao : null,
        ComprimentoPalete: this.removerNaoDigitos(this.comprimentoPalete),
        LarguraPalete: this.removerNaoDigitos(this.larguraPalete),
        AlturaPalete: this.removerNaoDigitos(this.alturaPalete),
        MelhorAproveitamento: this.melhorAproveitamento,
        ObservacaoPalete: this.observacaoPalete,
        PapelSeda: this.papelSeda,
        MedidaPapelSeda: this.medidaPapelSeda,
        MedidaPapelSeda2: this.medidaPapelSeda2
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Orcamento/postCaracteristicas/${this.$route.params.id}`,
        data: OrcamentoCaracteristicasArray
    })
        .then(() => {
            this.SalvarOrcamentoSequencia()
        })
        .catch(() => {
        });
    },

    SalvarOrcamentoSequencia(){
      this.$refs.botaoContinuar.isBusy()

      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'OrcamentoSequencia/PostOrcamentoSequencia',
        data: {
          InformacaoProdutosSequencia: this.InformacaoProdutosSequencia,
          orcamentoId: this.$route.params.id,
        }
      })
        .then((response) => {
          if (response.data && response.data.code < 0) {
            console.error('Erro ao gravar a sequência do orçamento:', response.data.message);
            this.$toast.add({ severity: 'error', summary: 'Sequência do orçamento', detail: 'Não foi possível gravar a sequência do orçamento. Tente novamente; se o erro continuar, acione o suporte.', life: 8000 });
            this.$isLoading(false)
            return;
          }

          // this.popup=true
          this.GetCodigoOrcamento();
          this.$isLoading(false)

          setTimeout(() => {
            this.EnviaOrcamentoCRM();
          }, 1000)
        })
        .catch((err) => {
          console.error('Erro ao gravar a sequência do orçamento:', err.message);
          this.$toast.add({ severity: 'error', summary: 'Sequência do orçamento', detail: 'Falha de comunicação ao gravar a sequência do orçamento. Verifique sua conexão e tente novamente.', life: 8000 });
          this.$isLoading(false)
        })
        .finally(() => this.$refs.botaoContinuar.isBusy()
        )
    },

    EnviaOrcamentoCRM(){
      this.axios({
        method: "post",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/EnviarOrcamentoCRM/${this.$route.params.id}`,
      })
      .then((response) => {
        if (response.data && response.data.code < 0) {
          console.error('Erro ao enviar orçamento para CRM:', response.data.message);
          this.$toast.add({ severity: 'warn', summary: 'Integração CRM', detail: 'O orçamento foi gravado, mas não foi possível integrá-lo ao CRM. Acione o suporte informando o número do orçamento.', life: 8000 });
        }
      })
      .catch((err) => {
        console.error('Erro ao enviar orçamento para CRM:', err.message);
        this.$toast.add({ severity: 'error', summary: 'Integração CRM', detail: 'O orçamento foi gravado, mas houve falha de comunicação com o CRM. Acione o suporte informando o número do orçamento.', life: 8000 });
      });
    },
    
    nullaDesc() {
      this.descricao = null
      this.descricaoespec = null
    },

    nullaCritica() {

      this.critica2 = false
      this.critica3 = false
      this.critica4 = false
      this.critica5 = false
    },

    finalizar () {
      if (this.sequenciaValue) {
        if(this.InformacaoProdutosSequencia.length < 2 && this.AbrirPopupPadrao)
        {
          this.$toast.add({ severity: 'error', summary: 'Selecione no mínimo 2 produtos da Sequência', detail: 'Selecione no mínimo 2 produtos da Sequência', life: 4000 });
          return
          }
        }

        this.validateCriticas();
    },


    voltarstep4() {
      if (this.checkAmostra == true || this.amostraTecnica == true)
      {
        this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/info-basicas-ra`)
      } else {
        this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/componentes-produto-ra`)
      }
    },

    fecharpopup(){
        this.popup=false
        this.insertOrcamentoVariacao()
    },

    paginafinalizada(){
        this.$router.push(`/orcamento-final-ra/${this.$route.params.id}`)
    },

    getComponentesByProdutoIdSelecionado(){
      this.axios({
        method:'get',
        url:process.env.VUE_APP_WEB_API +`Componente/GetComponentesByProdutoIdOrcamentoId/${this.$route.params.id}`
      })
      .then((Response)=>{
        Response.data.data.forEach((obj)=>{
          this.informacao.push(obj)


        })
        this.embalagemEspecificaCaixaColetiva = Response.data.data[0].embalagemEspecificaCaixaColetiva
        // this.embalagemEspecificaFilmeEncolhivel = Response.data.data[0].embalagemEspecificaFilmeEncolhivel
        this.embalagemEspecificaPalete =  Response.data.data[0].embalagemEspecificaPalete
        this.embalagemOutros =  Response.data.data[0].embalagemOutros
        this.critica1 =  Response.data.data[0].critica1
        this.critica2 =  Response.data.data[0].critica2
        this.critica3 =  Response.data.data[0].critica3
        this.critica4 =  Response.data.data[0].critica4
        this.critica5 =  Response.data.data[0].critica5
        this.observacao =  Response.data.data[0].observacoesGerais
        this.fsc = Response.data.data[0].fsc
        this.legislacao = Response.data.data[0].legislacao
        this.loteSelecionado = Response.data.data[0].lote
        this.sequenciaSelecionado = Response.data.data[0].sequencia
        /* this.embalagemOutros = Response.data.data[0].outros */
        /* this.legislacao = Response.data.data[]
        this.fsc =  */

        this.teste(Response.data.data)

        this.informacao.forEach((r)=>{
        r.ColunaMedidas = `${r.numeroAltura} x ${r.numeroComprimento} x ${r.numeroLargura}`
        })
        this.key++


      })
      .catch(()=>{
      })

    },

    getReorcamento(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetInfosBasicasProdutoNovo/${this.$route.params.id}`,
      })
        .then((Response) => {


          this.reorcamento = Response.data.data.reorcamento;
          this.copiaOrcamentoQuantidade = Response.data.data.copiaOrcamentoQuantidade;
          this.checkAmostra = Response.data.data.amostra
          this.amostraTecnica = Response.data.data.amostraEspecificacaoTecnica

          if( this.copiaOrcamentoQuantidade==false && this.reorcamento==false && this.status != 16  )
          {
            this.AbrirPopupPadrao = true
          }

          if( this.copiaOrcamentoQuantidade==null && this.reorcamento==null && this.status != 16 )
          {
            this.AbrirPopupPadrao = true
          }

          


        })
        .catch(() => {
        });
    },


    getCaracteristicasProduto(){
      OrcamentoController.GetCaracteristicasRepeticao(this.$route.params.id).requisicao
      .then(res => {
        this.status = res.data.data.status;
        this.fsc = res.data.data.fsc;
        this.tipoSelecionado = res.data.data.tipo;
        this.legislacao = res.data.data.legislacao;
        this.critica1 = res.data.data.critica1;
        this.critica2 = res.data.data.critica2;
        this.critica3 = res.data.data.critica3;
        this.critica4 = res.data.data.critica4;
        this.critica5 = res.data.data.critica5;
        // this.outros = res.data.data.embalagemOutros;
        this.outros = res.data.data.descricaoOutrasEmbalagens;
        this.descricaoespec = res.data.data.descricaoOutrasEmbalagensEspecificas;
        this.observacao = res.data.data.observacao;
        // this.embalagemEspecificaFilmeEncolhivel = res.data.data.embalagemEspecificaFilmeEncolhivel;
        // this.embalagemEspecificaCaixaColetiva = res.data.data.embalagemEspecificaCaixaColetiva;
        // this.embalagemEspecificaPalete = res.data.data.embalagemEspecificaPalete;
        this.loteSelecionado = res.data.data.lote;
        this.sequenciaDescricao =  res.data.data.descricaoSequencia;
        this.papelSeda = res.data.data.papelSeda;
        this.medidaPapelSeda = res.data.data.medidaPapelSeda;
        this.medidaPapelSeda2 = res.data.data.medidaPapelSeda2
      })
    },

    GetCodigoOrcamento(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetCodigoOrcamento/${this.$route.params.id}`,
      })
        .then((response) => {
          this.CodigoOrcamento = response.data.message
          this.popup=true


          if(this.copiaOrcamentoQuantidade == true)
            {
              this.AbrirPopupPadrao=false
              return
            }

            if(this.reorcamento == true)
              {
                this.AbrirPopupPadrao=false
                return
              }
              if(this.status == 16)
                {
                  this.AbrirPopupPadrao=false
                  return
                }
                this.AbrirPopupPadrao = true
        })
        .catch(() => {
        });
    },

  },



  computed: { },

  watch: {
    melhorAproveitamento(novoValor){
      if(novoValor){
        this.alturaPalete = ''
        this.comprimentoPalete = ''
      }
    },

    // critica1 () {
    //   this.nullaCritica()
    // }
  }

});